import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import { COOKIES_CONFIG } from './../configs/cookies.config';
import { ApiDashboardService } from './api-call-providers/api-dashboard.service';
import { DataCacheService } from './data-cache.service';

@Injectable()
export class DashboardService {

  // ダッシュボードに表示する患者データ一覧
  vitalsSource = new Subject<any>();
  patientVitals = this.vitalsSource.asObservable();

  constructor(
    private _dataCacheService: DataCacheService,
    private _apiDashboardService: ApiDashboardService,
  ) {
  }

  get loading() {
    return this._apiDashboardService.isLoading
  }

  /**
   * データの初期化
   */
  async load() {
    this._apiDashboardService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.DASHBOARD_DATA)
    if (!_data.isExist()) {
      await this.fetch();
      return
    }
    this._apiDashboardService.isLoading = false
    return this.vitalsSource.next(_data);
  }

  /**
   * ダッシュボードデータのロード
   */
  async fetch() {
    let res: any = await this._apiDashboardService.list()
    let data = { data: res.vitals }
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.DASHBOARD_DATA, res.vitals, res.expired)
    }
    this.vitalsSource.next(data)
  }

  /**
   * データに更新が入ったのでローカルのキャッシュを削除する
   */
  async remove() {
    this._dataCacheService.remove(COOKIES_CONFIG.DASHBOARD_DATA);
  }

  /**
   *         // TODO: 絞り込みのために利用しているが、あまりよろしくない...サーバ側で対応予定
        this.patientVitals = res.vitals.map(_pa => {
                              _pa.nameKana = _pa.patientNameKana;
                              return _pa;
                            });
   */
}



// WEBPACK FOOTER //
// ./src/providers/dashboard.service.ts